import { FuzzySearchInputType, SearchByInputType } from 'src/graphql/generated';

export type FilterArray = {
  label: string;
  value: string;
  field?: string;
  __isNew__: boolean;
}[];

export const setSearchFilter = (
  searchOptions: Array<{
    value: string;
    label: string;
    color?: string;
    field?: string;
  }>,
  filters?: FilterArray,
) => {
  const fieldFilters: SearchByInputType[] = [];
  let fuzzyFilter: FuzzySearchInputType | null = null;
  if (filters) {
    let currentFilter: string | null = null;
    for (const filter of filters) {
      if (!(filter.__isNew__ && currentFilter)) {
        for (const option of searchOptions) {
          if (filter.value === option.value) {
            currentFilter = option.value;
            if (filter.field && filter.field === option.field) {
              fieldFilters.push({
                fieldName: filter.field,
                fieldValue: filter.value,
              });
            }
          }
        }
      }
      if (filter.__isNew__) {
        if (currentFilter) {
          fieldFilters.push({
            fieldName: currentFilter,
            fieldValue: filter.value.toLowerCase(),
          });
        } else {
          fuzzyFilter = { value: filter.value.toLowerCase() };
        }
      }
    }
  }

  return {
    fieldFilters,
    fuzzyFilter,
  };
};
